import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { useLanguage } from '../context/LanguageContext';

const PrivacyPage = () => {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen flex flex-col bg-black" data-testid="privacy-page">
      <Header />
      
      <main className="flex-1 pt-20">
        {/* Hero */}
        <section className="bg-gradient-to-br from-gray-900 to-black py-16 px-4 border-b border-gray-800">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-3xl md:text-4xl font-black text-white mb-4">
              {language === 'nl' ? 'Privacybeleid' : 'Privacy Policy'}
            </h1>
            <p className="text-gray-400">
              {language === 'nl' ? 'Laatst bijgewerkt: december 2025' : 'Last updated: December 2025'}
            </p>
          </div>
        </section>

        {/* Content */}
        <section className="py-16 px-4 bg-black">
          <div className="max-w-3xl mx-auto prose prose-invert prose-rose">
            <h2 className="text-white">{language === 'nl' ? '1. Introductie' : '1. Introduction'}</h2>
            <p className="text-gray-400">
              {language === 'nl'
                ? 'Swipe je woning B.V. ("Swipe je woning", "wij", "ons") respecteert uw privacy en is toegewijd aan het beschermen van uw persoonlijke gegevens. Dit privacybeleid legt uit hoe wij uw informatie verzamelen, gebruiken en beschermen.'
                : 'Swipe je woning B.V. ("Swipe je woning", "we", "us") respects your privacy and is committed to protecting your personal data. This privacy policy explains how we collect, use and protect your information.'}
            </p>

            <h2 className="text-white">{language === 'nl' ? '2. Gegevens die wij verzamelen' : '2. Data we collect'}</h2>
            <p className="text-gray-400">{language === 'nl' ? 'Wij verzamelen de volgende categorieën gegevens:' : 'We collect the following categories of data:'}</p>
            <ul className="text-gray-400">
              <li>{language === 'nl' ? 'Accountgegevens: naam, e-mailadres, wachtwoord' : 'Account data: name, email address, password'}</li>
              <li>{language === 'nl' ? 'Profielgegevens: profieltype, nationaliteit, voorkeuren' : 'Profile data: profile type, nationality, preferences'}</li>
              <li>{language === 'nl' ? 'Gebruiksgegevens: swipe-geschiedenis, matches, berichten' : 'Usage data: swipe history, matches, messages'}</li>
              <li>{language === 'nl' ? 'Technische gegevens: IP-adres, browsertype, apparaatinformatie' : 'Technical data: IP address, browser type, device information'}</li>
              <li>{language === 'nl' ? 'Betalingsgegevens: via onze betalingsprovider Stripe' : 'Payment data: via our payment provider Stripe'}</li>
            </ul>

            <h2 className="text-white">{language === 'nl' ? '3. Hoe wij uw gegevens gebruiken' : '3. How we use your data'}</h2>
            <p className="text-gray-400">{language === 'nl' ? 'Wij gebruiken uw gegevens voor:' : 'We use your data for:'}</p>
            <ul className="text-gray-400">
              <li>{language === 'nl' ? 'Het tonen van relevante woningen op basis van uw voorkeuren' : 'Showing relevant properties based on your preferences'}</li>
              <li>{language === 'nl' ? 'Het faciliteren van matches en berichten' : 'Facilitating matches and messages'}</li>
              <li>{language === 'nl' ? 'Het verwerken van betalingen en abonnementen' : 'Processing payments and subscriptions'}</li>
              <li>{language === 'nl' ? 'Het versturen van belangrijke meldingen' : 'Sending important notifications'}</li>
              <li>{language === 'nl' ? 'Het voorkomen van fraude en misbruik' : 'Preventing fraud and abuse'}</li>
            </ul>

            <h2 className="text-white">{language === 'nl' ? '4. Delen van gegevens' : '4. Sharing of data'}</h2>
            <p className="text-gray-400">
              {language === 'nl'
                ? 'Wij delen uw profielgegevens met verhuurders wanneer u een woning "liked". Dit is essentieel voor het matching-proces. Verder delen wij uw gegevens alleen wanneer wij wettelijk verplicht zijn dit te doen.'
                : 'We share your profile data with landlords when you "like" a property. This is essential for the matching process. Furthermore, we only share your data when we are legally required to do so.'}
            </p>

            <h2 className="text-white">{language === 'nl' ? '5. Beveiliging' : '5. Security'}</h2>
            <p className="text-gray-400">
              {language === 'nl'
                ? 'Wij nemen passende technische en organisatorische maatregelen om uw gegevens te beschermen tegen ongeautoriseerde toegang, verlies of misbruik.'
                : 'We take appropriate technical and organizational measures to protect your data against unauthorized access, loss or misuse.'}
            </p>

            <h2 className="text-white">{language === 'nl' ? '6. Uw rechten' : '6. Your rights'}</h2>
            <p className="text-gray-400">{language === 'nl' ? 'U heeft het recht om:' : 'You have the right to:'}</p>
            <ul className="text-gray-400">
              <li>{language === 'nl' ? 'Inzage te vragen in uw gegevens' : 'Request access to your data'}</li>
              <li>{language === 'nl' ? 'Correctie van onjuiste gegevens te vragen' : 'Request correction of incorrect data'}</li>
              <li>{language === 'nl' ? 'Verwijdering van uw gegevens te vragen' : 'Request deletion of your data'}</li>
              <li>{language === 'nl' ? 'Uw account en alle data volledig te wissen' : 'Completely erase your account and all data'}</li>
            </ul>

            <h2 className="text-white">{language === 'nl' ? '7. Contact' : '7. Contact'}</h2>
            <p className="text-gray-400">
              {language === 'nl'
                ? 'Voor vragen over dit privacybeleid kunt u contact opnemen via privacy@swipejewoning.nl.'
                : 'For questions about this privacy policy, you can contact us at privacy@swipejewoning.nl.'}
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPage;
